import OrderOptimizerDetailsOtherRequest, {
  OrderOptimizerDetailsOtherQueryParams,
} from "./order-optimizer-details-other.request";

const createQueryParams = (
  request: OrderOptimizerDetailsOtherRequest
): OrderOptimizerDetailsOtherQueryParams => {
  return {
    taxiDriverAssociationId: request.taxiDriverAssociationId,
    excludedOrders: request.excludedOrders,
  };
};

const orderOptimizerDetailsOtherRequestFactory = {
  createQueryParams,
};

export default orderOptimizerDetailsOtherRequestFactory;
